 import config from '../../config/customer.api'
 import {Request} from '../shared/base.requests'

 const meetTheTeamModule = {
   namespaced: true,
   state: {
     teamList: [],
     teammate: {
       id: 0,
       fullName: '',
       title: '',
       photo: '',
       bio: '',
       isCustomerApp: false,
       salesPersonId: 0
     }

   },

   mutations: {
     setTeamList: function (state, data) {
       state.teamList = data
     },
     setSalesPerson: function (state, data) {
       state.teammate = data
       console.log(state.teammate)
     }
   },
   actions: {
     loadTeamList: function (context) {
       return new Promise((resolve, reject) => {
         Request.get(config.getCompanyDepartments)
        .then(responce => {
          if (responce.success) {
            context.commit('setTeamList', responce.model)
            resolve()
          }
        })
        .catch(error => {
          console.error('Load Deprantments Faild', error)
          reject()
        })
       })
     },
     loadSalesPerson: function (context, id) {
       var elem
       if (context.state.teamList && context.state.teamList.length > 0) {
         for (var count = 0; count < context.state.teamList.length; count++) {
           var team = context.state.teamList[count].departmentSales
           console.log(team.find(z => z.salesPersonId === +id))
           elem = team.find(z => z.salesPersonId === +id)
           if (elem) { break }
         }
         context.commit('setSalesPerson', elem)
       } else {
         return new Promise((resolve, reject) => {
           Request.get(config.getCompanyDepartments + '/' + id)
         .then(responce => {
           if (responce.success) {
             context.commit('setSalesPerson', responce.model)
             resolve()
           }
         })
         .catch(error => {
           console.error('Load SalesPerson Faild', error)
           reject()
         })
         })
       }
     },
     setCustomerToNewSalesPerson: function (context, id) {
       return new Promise((resolve, reject) => {
         Request.get(config.getCompanyDepartments + '/' + id + '/registerContact')
        .then(responce => {
          if (responce.model !== null) {
            resolve(responce.model)
          } else {
            resolve('home')
          }
        })
      .catch(error => {
        console.error('Load New DBC Faild', error)
        reject()
      })
       })
     }
   }
 }
 export default meetTheTeamModule



// WEBPACK FOOTER //
// ./scripts/src/store/meet.the.team.module.js